export default __webpack_public_path__ + "static/media/clinic12.09a545e5.jpg";